import { useState } from "react";
import { UploadExcelBtn } from "../../../ui";
import { Button, Col, Form, Row, Upload } from "antd";
import { DeliveredProcedureOutlined } from "@ant-design/icons";
import { messageError } from "../../../../helpers";

export const UploadExcelDiv = ({ loading, handleCargarExcel }) => {
  const [fileList, setFileList] = useState([]);
  const form = Form.useFormInstance();
  const fileExcel = Form.useWatch("fileExcel", form);
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList.slice(-1);
  };
  const props = {
    beforeUpload: async (file) => {
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";

      if (!isExcel) {
        messageError("Solo se permiten archivos Excel (.xls, .xlsx)");
        return Upload.LIST_IGNORE; // evita que se agregue a la lista
      }
      return false;
    },
    fileList,
  };
  return (
    <Row style={{ paddingBottom: 8 }}>
      <Col span={5}>
        <Form.Item
          name="fileExcel"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload
            key="subirExcel"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            maxCount={1}
            multiple={false}
            {...props}
          >
            <UploadExcelBtn />
          </Upload>
        </Form.Item>
      </Col>
      <Col span={6}>
        <Button
          icon={<DeliveredProcedureOutlined />}
          color="cyan"
          variant="solid"
          onClick={handleCargarExcel}
          loading={loading}
          disabled={fileExcel?.length === 0}
        >
          Cargar datos
        </Button>
      </Col>
    </Row>
  );
};
